export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_babyshower-906fc4e891ab5033a136c726fb7ea861.jpg";